import routes from "~/constants/routes";
import { useNavigationStore } from "@/store/navigation";
import { checkPlan } from "~/utils/PlanFeatureCheck";
import { sidebarOptions } from "~/types/NavigationStateType";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  const navigationStore = useNavigationStore();

  let path = to.fullPath.includes("?")
    ? to.fullPath.substring(0, to.fullPath.indexOf("?"))
    : to.fullPath;

  // Handle edge cases
  if (to.fullPath.includes("graph=articles")) {
    path = `${path}?graph=articles`;
  } else if (to.fullPath.includes("graph=topics")) {
    path = `${path}?graph=topics`;
  }

  let flag = false;
  routes.every((route) => {
    return route.subRoutes.every((subRoute) => {
      if (subRoute?.path !== "/" && path === subRoute?.path) {
        flag = true;
        navigationStore.setActiveSideBarOption(route.name as sidebarOptions);
        navigationStore.setActiveNavBarOption(subRoute.id);
        navigationStore.setActiveNavBarOptions(route.subRoutes);
        return false;
      }
      return true;
    });
  });

  // This block handles the edge case where we hit the search edit page
  // from the monitor tab of the sidebar
  if (path.includes("searches/edit")) {
    navigationStore.setActiveSideBarOption(routes[3].name as sidebarOptions);
    navigationStore.setActiveNavBarOption(routes[3].subRoutes[4].id);
    navigationStore.setActiveNavBarOptions(routes[3].subRoutes);
  }

  // This block handles the edge case where settings page doesn't display sidebars
  if (path.includes("#/settings/user")) {
    navigationStore.setActiveSideBarOption(routes[5].name as sidebarOptions);
    navigationStore.setActiveNavBarOption(routes[5].subRoutes[0].id);
    navigationStore.setActiveNavBarOptions(routes[5].subRoutes);
  }

  // If flag is false, no route was set and we should fall back to defaults
  if (!flag && path === "/pro/#/monitor") {
    navigationStore.setActiveSideBarOption(routes[0].name as sidebarOptions);
    navigationStore.setActiveNavBarOption(1);
    navigationStore.setActiveNavBarOptions(routes[0].subRoutes);
  }

  const activeRoute = navigationStore.activeNavBarOptions;
  activeRoute?.forEach((subRoute) => {
    // Enable nav bar options based on plan features
    const hasPlanFeature = checkPlan(
      localStorage.getItem("organization") ?? "{}",
      subRoute.translationKey,
    );

    if (hasPlanFeature) {
      navigationStore.setDisplay(subRoute.id, true);
    }
  });
});
